<template>
    <div class="empty">
        <img :src="empty_img" class="empty_img" alt="" />
        <div class="empty_text">{{empty_text}}</div>
    </div>
</template>
<script>
export default {
    name: "empty",
    components: {
    },
    props: {
        empty_text: {
            type: String,
            default:'没有数据'
        },
        empty_img: {
            type: String,
            default:require('@/assets/empty.png')
        },
    },
    data() {
        return {
        };
    },
    methods: {

    },
    watch:{

    },
    mounted() {

    },
    created() {}
  };
  </script>

  <style lang="less" scoped>
    .empty{
        margin: 1rem auto;
        .empty_img{
            width: 3rem;
            // margin: 1rem auto;
        }
        .empty_text{
            font-size: 12px;
            color: #b6b6b6;
            text-align: center;
        }
    }
  </style>


// WEBPACK FOOTER //
// src/components/empty.vue